
import { hydrateCSRTemplate } from '@fiverr-private/layout_lib/CSRTemplate';
import { handleCSRError } from '@fiverr-private/layout_lib/CSRTemplate';
import { loader } from '/home/circleci/app/packages/layout-footer-component/src/entries/BusinessPro';
const getRootElement = () => typeof document !== 'undefined' && document.querySelector('#Footer');
const lazyImport = () => import(
    /* webpackChunkName: "BusinessProLazyComponent" */
    /* webpackExports: ["default"] */
    '/home/circleci/app/packages/layout-footer-component/src/entries/BusinessPro?version=1'
);
const hydrateComponent = async () => {
    try {
        const { default: Component } = await lazyImport();
        const props = window.initialData['Footer'];
        const root = getRootElement();
        if (root) {
            hydrateCSRTemplate(Component, props, root, 'Footer', 'BusinessPro');
        }
    } catch(error) {
        handleCSRError(error, "Footer", "BusinessPro");
    }
};
const main = async () => {
    try {
        const root = getRootElement();
        if (root) {
            await loader(hydrateComponent, root);
        }
    } catch(error) {
        handleCSRError(error, "Footer", "BusinessPro");
    }
};
main();
export default main;
